module.exports = require("./ga-GB.d.ts");